const SHEET_NAME_INVALID_CHARS = /[:\\/?*[\]]/g;
export const EXCEL_SHEET_NAME_MAX_LENGTH = 31;

/**
 * Excel worksheet names: max 31 chars; cannot contain : \ / ? * [ ]
 * Used to build a stable, unique tab name from a report display name + time suffix.
 */
export function sanitizeTraceReportSheetName(raw: string): string {
    let base = raw.replace(SHEET_NAME_INVALID_CHARS, ' ').replace(/\s+/g, ' ').trim();
    if (base.length === 0) {
        base = 'Trace';
    }
    const suffix = `-${String(Date.now()).slice(-6)}`;
    const maxBase = EXCEL_SHEET_NAME_MAX_LENGTH - suffix.length;
    if (base.length > maxBase) {
        base = base.slice(0, maxBase).trim();
        if (base.length === 0) {
            base = 'T';
        }
    }
    const full = `${base}${suffix}`;
    return full.slice(0, EXCEL_SHEET_NAME_MAX_LENGTH);
}
